import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AspOrderListService } from '../asp-order-list/asp-order-list.service';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';
import { formatDate } from '@angular/common';
import { AnimationOptions } from 'ngx-lottie';
import { LottieModule } from 'ngx-lottie';
import { AspLoadingService } from '../asp-loading/asp-loading.service';

@Component({
  selector: 'app-asp-return-items',
  templateUrl: './asp-return-items.component.html',
  styleUrls: ['./asp-return-items.component.scss']
})
export class AspReturnItemsComponent implements OnInit {



requestExchange = false;
productUnused = false;
selectedReason = '';
reasons = [
  'Item mismatch issue',
  'Received damaged item',
  'Received wrong item',
  'Extra item delivered'
];
  isVisible: boolean;
  product: any;
  selectedQty: any;
  imageUploaded: boolean = false;
  showErrors: boolean;

selectedImages: { file: File; preview: string }[] = [];
  viewPage: boolean;
  addresses: any;
  contactName: string;
  date: any;
  day: string;
  orderKey: any;
  openSuccess: boolean;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  created: any;
  additionalComment: string='';
  returnWindowType: any;


  constructor(
    private cdRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private aspOrderListService: AspOrderListService,
    private resolver: ComponentFactoryResolver,
    private aspLoadingService: AspLoadingService,
  ) { }

  options: AnimationOptions = {
    path: './assets/images/order_created.json' // Replace with your JSON animation file URL
  };
  @ViewChild('reasonSection') reasonSection!: ElementRef;
@ViewChild('imageSection') imageSection!: ElementRef;
@ViewChild('checkboxSection') checkboxSection!: ElementRef;
@ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
 animationCreated(animationItem: any): void {
  }
  ngOnInit(): void {
    this.openPopup();
    this.getAdress();
    this.contactName=localStorage.getItem("contactName");
  }
  openPopup(){
    this.isVisible=true;
  }


incrementQty() {
  if (this.selectedQty < this.product.quantity) {
    this.selectedQty++;
  }else{
    this.toastr.error("You cannnot return more quantity than order")
  }
}

decrementQty() {
  if (this.selectedQty > 1) {
    this.selectedQty--;
  }else{
    this.toastr.error("You cannnot return 0 quantity of the order")
  }
}


onBack() {
  this.isVisible = false;
        const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
      const componentRef = this.container.createComponent(factory);
  
      // Access the instance and call the method
      const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
      // componentBInstance.ngOnInit();
      componentBInstance.closeSidebar(true);
      componentBInstance.getOrderDetails(this.orderKey);
}
itemResponse(item,date,orderKey){
  console.log("item",item);
this.product=item;
this.selectedQty=item.quantity;
this.date=date.data;
this.orderKey=orderKey;
// 1. Get current time
const now = new Date();

// 2. Add 12 hours
const futureDate = new Date(now.getTime() + 12 * 60 * 60 * 1000);

// 3. Create dates with no time for comparison
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
const futureDay = new Date(futureDate.getFullYear(), futureDate.getMonth(), futureDate.getDate());

// 4. Compare
if (futureDay.getTime() === today.getTime()) {
  
  this.day='Today';
} else {
  this.day='Tomorrow';
}

}


onProceed(): void {
  if (this.canProceed) {
    this.viewPage=true;
    console.log('Proceeding to pickup details...');
    return;
  }
  const imageUrls = this.selectedImages.map(img => img.preview);
  console.log('Images to upload:', imageUrls);

  this.showErrors = true;

  this.cdRef.detectChanges(); // force DOM update

  setTimeout(() => {
    if (!this.selectedReason && this.reasonSection) {
      this.reasonSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (this.selectedImages.length === 0 && this.imageSection) {
      this.imageSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (!this.productUnused && this.checkboxSection) {
      this.checkboxSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 100);
}

get canProceed(): boolean {
  return !!this.selectedReason &&this.selectedImages.length > 0 && this.productUnused;
}

onImagesSelected(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (!input.files) return;

  const files = Array.from(input.files);

  files.forEach(file => {
    const reader = new FileReader();
    reader.onload = () => {
      this.selectedImages.push({ file, preview: reader.result as string });
      this.imageUploaded = true;
    };
    reader.readAsDataURL(file);
  });

  // Reset input so user can upload same image again
  input.value = '';
}


removeImage(index: number): void {
  this.selectedImages.splice(index, 1);
  this.imageUploaded = this.selectedImages.length > 0;
}
getAdress(){
   this.aspOrderListService.getAdress().subscribe(
      res => {
        console.log("res",res);
        this.addresses = (res['data'].filter(item => item.addressType === "shipping")[0]);
        console.log("this.addresses",this.addresses)
      })
}
onBackPage(){
  this.viewPage=false
}
submitReturn() {
  const selectedFiles: File[] = this.selectedImages.map(img => img.file); 
let reason = this.selectedReason || '';

if (this.additionalComment.trim()) {
  reason += `\n\n${this.additionalComment}`;
}

if (this.requestExchange) {
  reason += `\n\nREQUEST EXCHANGE`;
}
this.returnWindowType = localStorage.getItem('returnWindowType');
console.log("this.retuernWindowType in return list page-----",this.returnWindowType);
 if (!this.returnWindowType) {
    this.toastr.error('Please select return type!');
    return; // stop submission if not set
  }

  const returnWindow = this.returnWindowType; // ✅ define it
this.aspLoadingService.show();
  this.aspOrderListService.uploadReturnImages(this.orderKey, this.product.partNumber, reason, this.selectedQty, selectedFiles,
    returnWindow).subscribe(
    res =>{
      this.aspLoadingService.hide();
      if (res['code'] === 200){
        console.log("resConfirm",res);
        this.created=res['data'][0];
        this.openSuccess=true;
        this.viewPage=false;
        this.isVisible=false;
        localStorage.removeItem("returnWindowType");
      }
      else{
        this.toastr.error(res['message'])
      }
    })
}
 
   loadorderdetails() {
      
    this.openSuccess=false;
      const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
      const componentRef = this.container.createComponent(factory);
  
      // Access the instance and call the method
      const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
      // componentBInstance.ngOnInit();
      componentBInstance.closeSidebar(true);
      componentBInstance.getOrderDetails(this.orderKey);
  
    }
displayDate(input: string | Date): string {
  const inputDate = new Date(input);
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const inputStr = inputDate.toDateString();
  const todayStr = today.toDateString();
  const tomorrowStr = tomorrow.toDateString();

  if (inputStr === todayStr) {
    return 'Today';
  } else if (inputStr === tomorrowStr) {
    return 'Tomorrow';
  } else {
    return formatDate(inputDate, 'MMM d', 'en-US'); // e.g. "Jul 25"
  }
}
}
